import { useEffect } from "react";
import { useDispatch } from "react-redux";
import likeImage from "../../assets/like.svg";
import unlikeImage from "../../assets/unlike.svg";
import {
  likeThunk,
  unlikeThunk,
} from "../../features/likeUnlike/likeUnlikeSlice";

import { fetchVideo } from "../../features/video/videoSlice";

export default function LikeUnlike({ likes, unlikes, id }) {
  const dispatch = useDispatch();

  const likeHandle = (likes) => {
    dispatch(likeThunk({ id, likes }));
    dispatch(fetchVideo(id));
  };
  const unlikeHandle = () => {
    dispatch(unlikeThunk({ id, unlikes }));
    dispatch(fetchVideo(id));
  };
  return (
    <div class="flex gap-10 w-48">
      <div class="flex gap-1">
        <div class="shrink-0">
          <img
            class="w-5 block"
            src={likeImage}
            alt="Like"
            onClick={() => likeHandle(likes)}
          />
        </div>
        <div class="text-sm leading-[1.7142857] text-slate-600">{likes}</div>
      </div>
      <div class="flex gap-1">
        <div class="shrink-0">
          <img
            class="w-5 block"
            src={unlikeImage}
            alt="Unlike"
            onClick={() => unlikeHandle(unlikes)}
          />
        </div>
        <div class="text-sm leading-[1.7142857] text-slate-600">{unlikes}</div>
      </div>
    </div>
  );
}
